import React from 'react'
import { useWindowSize } from 'react-use'
import RenovationCard from '../molecules/RenovationCard'

const RenovationCardList = ({ cards, openCardId, onToggleCard }) => {
  const { width } = useWindowSize()
  const singleList = width < 1024

  return (
    <>
      <div className="grid grid-cols-1 gap-10 lg:block lg:pt-20 space-y-14">
        {cards
          .filter((_, i) => singleList || i % 2 === 0)
          .map(card => (
            <RenovationCard
              key={card.id}
              card={card}
              isOpen={openCardId === card.id}
              isDisabled={openCardId !== null && openCardId !== card.id}
              onToggle={() => onToggleCard(card.id)}
            />
          ))}
      </div>

      <div className="hidden lg:block space-y-14">
        {cards
          .filter((_, i) => i % 2 === 1)
          .map(card => (
            <RenovationCard
              key={card.id}
              card={card}
              isOpen={openCardId === card.id}
              isDisabled={openCardId !== null && openCardId !== card.id}
              onToggle={() => onToggleCard(card.id)}
            />
          ))}
      </div>
    </>
  )
}

export default RenovationCardList
